import { Box, Tooltip, TooltipProps, Typography } from '@mui/material'
import { FC, PropsWithChildren } from 'react'
import { useWrapperStore } from '../../../../store/storeWrapper'

type Props = PropsWithChildren<{
    title: string
    placement?: TooltipProps['placement']
}>

export const SidebarTooltip: FC<Props> = ({ children, title,   titleTariff, placement = 'right' }) => {
    const { stepOnboarding } = useWrapperStore((state) => state)
    return (
        <Tooltip
            enterTouchDelay={0}
            title={
                <Typography variant="caption" color="#FFFFFF">
                    {title}
                    <Box>{titleTariff}</Box>
                </Typography>
            }

            placement={placement}
            slotProps={{
                tooltip: {
                    sx: {
                        visibility: stepOnboarding === 100 ? 'visible': 'hidden',
                        cursor: stepOnboarding === 100 ? 'pointer' : 'none',
                        marginBottom: '0px !important',
                        backgroundColor: '#322F35',
                    },
                },
            }}>
            <Box
                sx={{
                    minHeight: '36px',
                    display: 'flex',
                    alignItems: 'center',
                }}>
                {children}
            </Box>
        </Tooltip>
    )
}
